// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as SitemapCheckRouteImport } from './routes/sitemap-check'
import { Route as SeoChecklistRouteImport } from './routes/seo-checklist'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as MarcaRouteImport } from './routes/marca'
import { Route as HistoricoRouteImport } from './routes/historico'
import { Route as GuiaCompletoMei2026RouteImport } from './routes/guia-completo-mei-2026'
import { Route as DownloadAppRouteImport } from './routes/download-app'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FerramentasIndexRouteImport } from './routes/ferramentas.index'
import { Route as ArtigosIndexRouteImport } from './routes/artigos.index'
import { Route as FerramentasIaMeiRouteImport } from './routes/ferramentas.ia-mei'
import { Route as FerramentasContratosPdfRouteImport } from './routes/ferramentas.contratos-pdf'
import { Route as FerramentasComparadorMaquininhasRouteImport } from './routes/ferramentas.comparador-maquininhas'
import { Route as FerramentasSlugRouteImport } from './routes/ferramentas.$slug'
import { Route as ArtigosSlugRouteImport } from './routes/artigos.$slug'
import { Route as AdminDownloadsRouteImport } from './routes/admin.downloads'
import { Route as AdminAvaliacoesRouteImport } from './routes/admin.avaliacoes'
import { Route as FerramentasIaCnaeMeiSlugRouteImport } from './routes/ferramentas.ia-cnae-mei.$slug'

const TermosRoute = TermosRouteImport.update({
            id: '/termos',path: '/termos',getParentRoute: () => rootRouteImport
          })
const SitemapCheckRoute = SitemapCheckRouteImport.update({
            id: '/sitemap-check',path: '/sitemap-check',getParentRoute: () => rootRouteImport
          })
const SeoChecklistRoute = SeoChecklistRouteImport.update({
            id: '/seo-checklist',path: '/seo-checklist',getParentRoute: () => rootRouteImport
          })
const PrivacidadeRoute = PrivacidadeRouteImport.update({
            id: '/privacidade',path: '/privacidade',getParentRoute: () => rootRouteImport
          })
const MarcaRoute = MarcaRouteImport.update({
            id: '/marca',path: '/marca',getParentRoute: () => rootRouteImport
          })
const HistoricoRoute = HistoricoRouteImport.update({
            id: '/historico',path: '/historico',getParentRoute: () => rootRouteImport
          })
const GuiaCompletoMei2026Route = GuiaCompletoMei2026RouteImport.update({
            id: '/guia-completo-mei-2026',path: '/guia-completo-mei-2026',getParentRoute: () => rootRouteImport
          })
const DownloadAppRoute = DownloadAppRouteImport.update({
            id: '/download-app',path: '/download-app',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ContatoRoute = ContatoRouteImport.update({
            id: '/contato',path: '/contato',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const FerramentasIndexRoute = FerramentasIndexRouteImport.update({
            id: '/ferramentas/',path: '/ferramentas/',getParentRoute: () => rootRouteImport
          })
const ArtigosIndexRoute = ArtigosIndexRouteImport.update({
            id: '/artigos/',path: '/artigos/',getParentRoute: () => rootRouteImport
          })
const FerramentasIaMeiRoute = FerramentasIaMeiRouteImport.update({
            id: '/ferramentas/ia-mei',path: '/ferramentas/ia-mei',getParentRoute: () => rootRouteImport
          })
const FerramentasContratosPdfRoute = FerramentasContratosPdfRouteImport.update({
            id: '/ferramentas/contratos-pdf',path: '/ferramentas/contratos-pdf',getParentRoute: () => rootRouteImport
          })
const FerramentasComparadorMaquininhasRoute = FerramentasComparadorMaquininhasRouteImport.update({
            id: '/ferramentas/comparador-maquininhas',path: '/ferramentas/comparador-maquininhas',getParentRoute: () => rootRouteImport
          })
const FerramentasSlugRoute = FerramentasSlugRouteImport.update({
            id: '/ferramentas/$slug',path: '/ferramentas/$slug',getParentRoute: () => rootRouteImport
          })
const ArtigosSlugRoute = ArtigosSlugRouteImport.update({
            id: '/artigos/$slug',path: '/artigos/$slug',getParentRoute: () => rootRouteImport
          })
const AdminDownloadsRoute = AdminDownloadsRouteImport.update({
            id: '/admin/downloads',path: '/admin/downloads',getParentRoute: () => rootRouteImport
          })
const AdminAvaliacoesRoute = AdminAvaliacoesRouteImport.update({
            id: '/admin/avaliacoes',path: '/admin/avaliacoes',getParentRoute: () => rootRouteImport
          })
const FerramentasIaCnaeMeiSlugRoute = FerramentasIaCnaeMeiSlugRouteImport.update({
            id: '/ferramentas/ia-cnae-mei/$slug',path: '/ferramentas/ia-cnae-mei/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ContatoRoute: ContatoRoute,CookiesRoute: CookiesRoute,DownloadAppRoute: DownloadAppRoute,GuiaCompletoMei2026Route: GuiaCompletoMei2026Route,HistoricoRoute: HistoricoRoute,MarcaRoute: MarcaRoute,PrivacidadeRoute: PrivacidadeRoute,SeoChecklistRoute: SeoChecklistRoute,SitemapCheckRoute: SitemapCheckRoute,TermosRoute: TermosRoute,AdminAvaliacoesRoute: AdminAvaliacoesRoute,AdminDownloadsRoute: AdminDownloadsRoute,ArtigosSlugRoute: ArtigosSlugRoute,FerramentasSlugRoute: FerramentasSlugRoute,FerramentasComparadorMaquininhasRoute: FerramentasComparadorMaquininhasRoute,FerramentasContratosPdfRoute: FerramentasContratosPdfRoute,FerramentasIaMeiRoute: FerramentasIaMeiRoute,ArtigosIndexRoute: ArtigosIndexRoute,FerramentasIndexRoute: FerramentasIndexRoute,FerramentasIaCnaeMeiSlugRoute: FerramentasIaCnaeMeiSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)